import React from 'react';
import classNames from 'classnames/bind';
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
export var BannerContainer = function BannerContainer(_ref) {
  var maxWidth = _ref.maxWidth,
    children = _ref.children,
    href = _ref.href,
    isBlankUrlTarget = _ref.isBlankUrlTarget;
  var Tag = href ? 'a' : 'div';
  return /*#__PURE__*/React.createElement(Tag, {
    className: cx('container'),
    href: href,
    style: {
      maxWidth: maxWidth
    },
    target: isBlankUrlTarget ? '_blank' : '_self',
    "data-t-id": "components-BannerContainer"
  }, children);
};